import React from 'react';

function AnythingDetailsLink({ anything, ...rest }) {
  const { value1: targetUrl, value2: linkName } = anything;

  return (
    <div {...rest}>
      <a
        href={targetUrl}
        rel="noreferrer noopener"
        target="_blank"
        alt={`Link to ${linkName}`}
      >
        {linkName}
      </a>
    </div>
  );
}

export default AnythingDetailsLink;
